import { render, staticRenderFns } from "./StructureComposition.vue?vue&type=template&id=131e2711&scoped=true&"
import script from "./StructureComposition.vue?vue&type=script&lang=js&"
export * from "./StructureComposition.vue?vue&type=script&lang=js&"
import style0 from "./StructureComposition.vue?vue&type=style&index=0&id=131e2711&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e2711",
  null
  
)

export default component.exports